import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { SpinnerComponent } from './spinner.component';

@NgModule({
    imports: [CommonModule, MatProgressSpinnerModule],
    declarations: [SpinnerComponent],
    exports: [SpinnerComponent],
})
export class LibSpinnerModule {}
